module.exports = __webpack_public_path__ + "img/12.0e6b8637.jpg";